import React, { useState, useEffect, useRef } from "react";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import InfoIcon from "@mui/icons-material/Info";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import { Getrequestcall } from "../../../request/Getrequest";
import { GET_MUSICE } from "../../../constant/Apipath";
import { setShowalert } from "../../../redux/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";

function GetMusicModal({ 
  open, 
  onClose, 
  loginData, 
  setMusicName, 
  setMusicFileUrl, 
  pictureList, 
  play, 
  setPlay 
}) {
  const audioRef = useRef(null);
  const dispatch = useDispatch();
  const [musicFiles, setMusicFiles] = useState([]);
  const [musicUrl, setMusicUrl] = useState("");
  
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Montages || {};
  const { TEXT_SOUNDS = English.Montages.TEXT_SOUNDS } = LanguageData || {};

  function handlePlayAudio(url) {
    if (!url) {
      console.error("handlePlayAudio-> Error As The Audio URL Is Invalid: ", url);
      return;
    }
    setMusicUrl(url);
    setTimeout(() => {
      if (audioRef.current) {
        audioRef.current
          .play()
          .catch((error) =>
            console.error("handlePlayAudio-> Error When Trying To Playing Audio: ", error)
          );
      }
    }, 100);
  }

  function handleChangeMusic(fileUrl) {
    setMusicFileUrl(fileUrl);

    if (pictureList.length !== 0) {
      if (play) {
        handlePlayAudio(fileUrl);
      }
    } else {
      setPlay(false);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }
  }

  function handleInfoClick(item) {
    dispatch(
      setShowalert({
        showAlert: true,
        title: item.name,
        text: item.description
      })
    );
  }

  const fetchMusices = async () => {
    try {
      const res = await Getrequestcall(GET_MUSICE, loginData?.accessToken);
      setMusicFiles(res.data.data);
    } catch (error) {
      console.error("fetchMusices-> Error While Fetching Music Files: ", error);
    }
  };

  const handleClose = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    onClose();
  };

  const handleMusicSelect = (item) => {
    setMusicName(item.name);
    handleChangeMusic(item.fileUrl);
    onClose();
  };

  useEffect(() => {
    if (open) {
      fetchMusices();
    }
  }, [open]);

  if (!open) return null;

  return (
    <>
      {musicUrl && <audio ref={audioRef} src={musicUrl} controls style={{ display: "none" }} />}
      <Modal open={open}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6"> {TEXT_SOUNDS} </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className="main-content-card-list">
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >
                {musicFiles?.map((item, index) => {
                  return (
                    <Card
                      key={index.toString()}
                      className="pagelist-content"
                      sx={{ marginTop: "0px" }}>
                      <ListItem
                        sx={{ m: 0 }}
                        key={index.toString()}
                        secondaryAction={
                          <IconButton onClick={() => handleInfoClick(item)}>
                            <InfoIcon />
                          </IconButton>
                        }
                        disablePadding>
                        <ListItemButton
                          sx={{
                            display: "flex",
                            flexDirection: "row"
                          }}
                          onClick={() => handleMusicSelect(item)}>
                          <ListItemAvatar>
                            <Avatar>
                              <PlayCircleIcon />
                            </Avatar>
                          </ListItemAvatar>

                          <ListItemText primary={item.name} />
                        </ListItemButton>
                      </ListItem>
                    </Card>
                  );
                })}
              </Stack>
            </List>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default GetMusicModal;

